import {appAPI} from "../../../api";
import {IFuelCalibration, IFuelTank, ILiveAin} from "../../../models/IFuelCalibration";

const calibrationPath = `/fuel_calibration`;
const locationPath = `/machinery-current-location`;

// Единая обработка ошибки — как в machineryAPI.
const extractError = (error: any): string =>
    error.response?.data?.message ||
    error.response?.data?.detail ||
    `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`;

export const fuelCalibrationAPI = {
    // Тарировка машины (массив баков с точками). Бэк отдаёт массив записей баков.
    getByMachinery: async (machineryId: string): Promise<IFuelTank[]> => {
        const res = await appAPI.get(`${calibrationPath}/${machineryId}`);
        return res.data;
    },

    // Полная замена тарировки одной транзакцией (PUT).
    save: async (
        machineryId: string,
        data: IFuelCalibration,
    ): Promise<IFuelTank[]> => {
        try {
            const res = await appAPI.put(`${calibrationPath}/${machineryId}`, data);
            return res.data;
        } catch (error: any) {
            throw new Error(extractError(error));
        }
    },

    // Удалить тарировку машины целиком.
    remove: async (machineryId: string): Promise<void> => {
        try {
            await appAPI.delete(`${calibrationPath}/${machineryId}`);
        } catch (error: any) {
            throw new Error(extractError(error));
        }
    },

    // Живые показания входов для тарировки (поллинг).
    getLiveAin: async (machineryId: string): Promise<ILiveAin> => {
        const res = await appAPI.get(`${locationPath}/${machineryId}/live-ain`);
        return res.data;
    },
};